import React from "react";
import Flyer from "../components/Flyer";

const Menu = () => {
  return <Flyer />;
};

export default Menu;
